import { graphql } from '@eluve/graphql.tada';
import { tenantNameFragment } from '@eluve/smart-blocks';

import { usersTenantsFragment } from '../tenant/components/TenantActionsColumn';

export const getAppointmentTenantInfoQuery = graphql(
  `
    query getAppointmentTenantInfo($appointmentId: uuid!) {
      appointments(where: { id: { _eq: $appointmentId } }, limit: 1) {
        __typename
        id
        tenantId
        tenant {
          ...TenantName
        }
      }
    }
  `,
  [tenantNameFragment],
);

export const getCommandPaletteUserTenantsQuery = graphql(
  `
    query getCommandPaletteUserTenants($userId: uuid!) {
      usersByPk(id: $userId) {
        ...UsersTenants
      }
    }
  `,
  [usersTenantsFragment],
);
